import { h, Fragment } from 'preact';
import { useEffect, useMemo, useRef, useState } from 'preact/hooks';

import ProfileLayout from '../../../components/layouts/ProfileLayout';
import { useSignal, useSignalEffect } from '@preact/signals';
import { GlobalState } from '../../../states/global-state';
import Store from '../../../stores/Store';
import CustomHeight from '../../../components/height/custom-height';
import ProfileTab from '../../../components/profile-tab';
import CustomButton from '../../../components/button';
import FormValidator from 'simple-form-valid';
import Validator from '../../../scripts/validator';
import getFormData from '../../../scripts/FormData';
import CustomPasswordControl from '../../../components/form/controls/custom-password';
import { changePassword } from '../../../controllers/UserApiControler';

interface Props {
  user: string;
}

// Note: `user` comes from the URL, courtesy of our router
const ProfileChangePassword = ({ user }: Props) => {
  const store = useMemo(() => new Store(), []);
  const datas = useSignal([]);
  const formRef = useRef<HTMLFormElement>(null);
  const [formValidation, setFormValidation] = useState(null);

  useSignalEffect(() => {
    store.getProfileData().then(res => {
      datas.value = [
        ['First Name', res.firstName],
        ['Middle Name', res.middleName],
        ['Last Name', res.lastName],
      ];
    });
  });

  useEffect(() => {
    setFormValidation(
      new FormValidator(formRef.current, Validator, {
        // class of the parent element where the error/success class is added
        parentClass: 'form-group',
        errorClass: 'invalid',
        successClass: 'valid',
        // class of the parent element where error text element is appended
        errorTextParent: 'form-group',
        // type of element to create for the error text
        errorTextTag: 'div',
        // class of the error text element
        errorTextClass: 'invalid-feedback',
      })
    );
  }, []);

  const submitHandler = async e => {
    e.preventDefault();

    const valid = await formValidation.validate('.input');

    if (!valid) {
      return;
    }

    const data = getFormData<{
      old_password: string;
      new_password: string;
      confirm_password: string;
    }>(e.target);

    // console.log(70, data);

    const submit = await changePassword(data);

    // console.log(76, submit);
  };

  return (
    <ProfileLayout>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/profile">Profile</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Change Password
          </li>
        </ol>
      </nav>

      <hr />

      <h3>Change Password</h3>
      <form
        style={{ width: '30vw', minWidth: '300px' }}
        onSubmit={submitHandler}
        ref={formRef}
      >
        <CustomPasswordControl
          placeholder="old password"
          name="old_password"
          display="Old Password"
          hasValidate={false}
        />
        <CustomPasswordControl
          placeholder="new password"
          name="new_password"
          display="New Password"
        />
        <CustomPasswordControl
          placeholder="confirm password"
          name="confirm_password"
          display="Confirm Password"
        />
        <CustomHeight height="48px" />
        <CustomButton
          type="submit"
          class="btn btn-success"
          isLoading={GlobalState.showSpinner.value}
        >
          Submit Change Password
        </CustomButton>
        &nbsp;&nbsp;
        <CustomButton type="button" class="btn btn-outline-warning">
          Cancel
        </CustomButton>
      </form>

      <CustomHeight height="20vh" />
    </ProfileLayout>
  );
};

export default ProfileChangePassword;
